import { render, staticRenderFns } from "./TeamIndex.vue?vue&type=template&id=f18880e2&scoped=true&"
import script from "./TeamIndex.vue?vue&type=script&lang=js&"
export * from "./TeamIndex.vue?vue&type=script&lang=js&"
import style0 from "./TeamIndex.vue?vue&type=style&index=0&id=f18880e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18880e2",
  null
  
)

export default component.exports